<template>
    <div
        class="splash-screen-web-cover"
        @click="closeSplashSceen()"
        v-if="isShow"
    ></div>
    <transition name="slide-up">
        <div class="splash-screen-web" v-if="isShow">
            <div class="splash-screen-banner">
                <!-- @command: banner -->
                <div class="splash-screen-banner-box">
                    <img
                        src="@static/images/splashScreen/splash_screen_banner.png"
                        class="splash-screen-banner-img"
                    />
                </div>
            </div>
            <div class="splash-desc-container">
                <div class="splash-screen-data">
                    <!-- @command: timer -->
                    <div class="splash-screen-timer" v-if="!parentOpen">
                        {{ countDownTime }}
                    </div>

                    <!-- @command: logo -->
                    <div class="splash-screen-logo-box">
                        <IconMode>
                            <template #default="{ index }">
                                <img
                                    src="@static/images/icons/aspn_icon/logo/logo-light.png"
                                    v-if="
                                        ['lightWeb', 'lightWebapp'].includes(
                                            index
                                        )
                                    "
                                    class="splash-screen-logo"
                                />
                                <img
                                    src="@static/images/icons/aspn_icon/logo/logo-dark.png"
                                    v-else-if="
                                        ['darkWeb', 'darkWebapp'].includes(
                                            index
                                        )
                                    "
                                    class="splash-screen-logo"
                                />
                            </template>
                        </IconMode>
                    </div>

                    <!-- @command: title -->
                    <div
                        class="splash-screen-title"
                        :class="currentLanguageObj.displayLocale"
                    >
                        <div>{{ $t("DOWNLOAD") }}</div>
                        <div>{{ $t("OUR_NEW_APP") }}</div>
                    </div>

                    <!-- @command: QR code -->
                    <div class="splash-screen-qr-box">
                        <img
                            src="@static/images/splashScreen/qr_code_deviceChecking.png"
                            class="splash-screen-qr-img"
                        />
                    </div>

                    <!-- @command: available -->
                    <div class="splash-screen-available">
                        <div class="splash-screen-available-content-box">
                            <div
                                class="splash-screen-available-content-container"
                            >
                                <div class="splash-screen-available-content">
                                    {{ $t("AVAILABLE_NOW") }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="splash-screen-download-list">
                        <!-- @command: play store -->
                        <a :href="configApp.android.link">
                            <div class="splash-screen-download-item">
                                <img
                                    src="@static/images/splashScreen/play_store_icon.png"
                                    class="splash-screen-download-icon"
                                />
                                <div class="splash-screen-download-content">
                                    <div
                                        class="splash-screen-download-small-text"
                                    >
                                        {{ $t("GET_IT_ON") }}
                                    </div>
                                    <div>{{ $t("GOOGLE_PLAY") }}</div>
                                </div>
                            </div>
                        </a>

                        <!-- @command: app store -->
                        <a :href="configApp.apple.link">
                            <div class="splash-screen-download-item">
                                <IconMode>
                                    <template #default="{ index }">
                                        <img src="@static/images/splashScreen/app_store_icon.png" 
                                            v-if="['lightWeb','lightWebapp'].includes(index)"
                                            class="splash-screen-download-icon" />
                                        <img src="@static/images/icons/aspn_icon/download/icon_apple_dark.png" 
                                            v-else-if="['darkWeb','darkWebapp'].includes(index)"
                                            class="splash-screen-download-icon" />
                                    </template>
                                </IconMode> 
                                <div class="splash-screen-download-content">
                                    <div
                                        class="splash-screen-download-small-text"
                                    >
                                        {{ $t("DOWNLOAD_ON_THE") }}
                                    </div>
                                    <div>{{ $t("APP_STORE") }}</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="splash-screen-header">
                    <div class="splash-screen-skip" @click="closeSplashSceen()">
                        {{ $t("SKIP") }}
                        <SvgIcon
                            icon="splashScreen.skip.arrow"
                            class="ml-05rem"
                        ></SvgIcon>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="slide-up">
        <div class="splash-screen-mobile" v-if="isShow">
            <!-- @command: header -->
            <div class="splash-screen-header">
                <div class="splash-screen-skip" @click="closeSplashSceen()">
                    {{ $t("SKIP") }} {{ !parentOpen ? countDownTime : "" }}
                    <!-- @command: timer -->
                    <!-- <div class="splash-screen-timer">
                        
                    </div> -->
                </div>
            </div>

            <!-- @command: logo -->
            <div class="splash-screen-logo-box">
                <IconMode>
                    <template #default="{ index }">
                        <img
                            src="@static/images/icons/aspn_icon/logo/logo-light.png"
                            v-if="['lightWeb', 'lightWebapp'].includes(index)"
                            class="splash-screen-logo"
                        />
                        <img
                            src="@static/images/icons/aspn_icon/logo/logo-dark.png"
                            v-else-if="
                                ['darkWeb', 'darkWebapp'].includes(index)
                            "
                            class="splash-screen-logo"
                        />
                    </template>
                </IconMode>
            </div>

            <!-- @command: title -->
            <div class="splash-screen-title">
                <div>{{ $t("DOWNLOAD_OUR") }}</div>
                <div>{{ $t("NEW_APP") }}</div>
            </div>

            <!-- @command: banner -->
            <div class="splash-screen-banner-box">
                <img
                    src="@static/images/splashScreen/splash_screen_banner_app.png"
                    class="splash-screen-banner-img"
                />
            </div>

            <!-- @command: available -->
            <div class="splash-screen-available">
                <div class="splash-screen-available-content-box">
                    <div class="splash-screen-available-content-container">
                        <div class="splash-screen-available-content">
                            {{ $t("AVAILABLE_NOW") }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="splash-screen-download-list">
                <!-- @command: play store -->
                <a :href="configApp.android.link">
                    <div class="splash-screen-download-item">
                        <img
                            src="@static/images/splashScreen/play_store_icon.png"
                            class="splash-screen-download-icon"
                        />
                        <div class="splash-screen-download-content">
                            <div class="splash-screen-download-small-text">
                                {{ $t("GET_IT_ON") }}
                            </div>
                            <div>{{ $t("GOOGLE_PLAY") }}</div>
                        </div>
                    </div>
                </a>

                <!-- @command: app store -->
                <a :href="configApp.apple.link">
                    <div class="splash-screen-download-item">
                        <IconMode>
                            <template #default="{ index }">
                                <img src="@static/images/splashScreen/app_store_icon.png" 
                                    v-if="['lightWeb','lightWebapp'].includes(index)"
                                    class="splash-screen-download-icon" />
                                <img src="@static/images/icons/aspn_icon/download/icon_apple_dark.png" 
                                    v-else-if="['darkWeb','darkWebapp'].includes(index)"
                                    class="splash-screen-download-icon" />
                            </template>
                        </IconMode> 
                        <div class="splash-screen-download-content">
                            <div class="splash-screen-download-small-text">
                                {{ $t("DOWNLOAD_ON_THE") }}
                            </div>
                            <div>{{ $t("APP_STORE") }}</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </transition>
</template>

<script>
import config from "@/js/config.js";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            parentOpen: false,
            isShow: false,
            countDownTime: 5,
            configApp: config.app,
        };
    },
    computed: {
        ...mapGetters(["currentLanguageObj"]),
    },
    beforeUnmount() {
        window.removeEventListener("popstate", this.handlePopState);
    },
    mounted() {
        if (!this.isComponent) {
            this.init();
        }

        window.history.pushState(null, "", window.location.href);
        this.handlePopState = (event) => {
            this.onBackButtonPressed();
        };
        window.addEventListener("popstate", this.handlePopState);
    },
    props: {
        isComponent: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onBackButtonPressed() {
            this.isShow = false;
            this.parentOpen = false;
        },
        closeSplashSceen() {
            if (this.parentOpen) {
                this.isShow = false;
                this.parentOpen = false;
            } else {
                this.isShow = false;
                let params = {
                    date: new Date(),
                };
                localStorage.setItem("splashSceen", JSON.stringify(params));
            }
        },
        init() {
            if (config.splashScreen === false) {
                this.isShow = false;
                return;
            }
            let splashScreen = JSON.parse(localStorage.getItem("splashSceen"));
            if (splashScreen) {
                let hours = moment().diff(moment(splashScreen.date), "hours");
                if (hours >= 24) {
                    this.isShow = true;
                    this.initCountDown();
                } else {
                    this.isShow = false;
                }
            } else {
                this.isShow = true;
                this.initCountDown();
            }
        },
        initCountDown() {
            let countDownInterval = setInterval(() => {
                if (this.countDownTime <= 0) {
                    clearInterval(countDownInterval);
                    this.closeSplashSceen();
                } else {
                    this.countDownTime--;
                }
            }, 1000);
        },
        parentOpenAndClose() {
            this.parentOpen = true;
            this.isShow = !this.Show;
        },
    },
};
</script>

<style scoped>
.splash-screen-web-cover {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.5);
}
.splash-screen-web {
    width: 900px;
    height: 600px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    z-index: 100;
    background-color: var(--color-background-default-default);
    border-radius: 24px;
    display: flex;
    align-items: flex-end;
    gap: 9.8px;
}
.splash-screen-mobile {
    display: none;
}
.splash-screen-data {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    margin-right: 30px;
}
.splash-desc-container {
    width: 100%;
    padding-right: 24px;
}
.splash-screen-timer {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-background-default-tertiary);
    color: var(--color-button-active);
}
.splash-screen-logo-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 18px;
    box-sizing: border-box;
}
.splash-screen-logo {
    height: 66px;
}
.splash-screen-banner {
    flex-shrink: 0;
}
.splash-screen-banner-box {
    display: flex;
    flex: 1;
}
.splash-screen-banner-img {
    width: 100%;
    height: calc(600px - 64px);
}
.splash-screen-qr-box {
}
.splash-screen-qr-img {
    width: 120px;
    height: 120px;
}
.splash-screen-title {
    text-align: center;
    font-size: 48px;
    color: var(--color-text-default-default);
    /* margin: 16px 0; */
    line-height: 120%;
    letter-spacing: -0.96px;
    box-sizing: border-box;
}
.splash-screen-title.pt {
    font-size: 47px;
}
.splash-screen-title.kh {
    font-size: 46px;
}
.splash-screen-title.ja {
    font-size: 40px;
}
.splash-screen-title.vn {
    font-size: 37px;
}
.splash-screen-download-list {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
}
.splash-screen-download-list a {
    width: 164px;
}
.splash-screen-download-item {
    background-color: var(--color-background-default-tertiary);
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px;
    box-sizing: border-box;
    flex: 1;
}
/* .splash-screen-download-item:hover {
    background-color: var(--color-background-default-tertiary-hover);
} */
.splash-screen-download-icon {
    height: 40px;
    width: 40px;
    flex-shrink: 0;
}
.splash-screen-download-content {
    color: var(--color-text-default-default);
    font-size: 19px;
    font-family: "Rubik400";
}
.splash-screen-download-small-text {
    font-size: 10px;
}
.splash-screen-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 24px;
    margin-top: 16px;
}
.splash-screen-skip {
    color: var(--color-text-default-default);
    font-size: 16px;
    font-family: var(--weight-600);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.splash-screen-available {
    width: 100%;
}
.splash-screen-available-content-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 18px;
    box-sizing: border-box;
    position: relative;
}
.splash-screen-available-content-container {
    padding: 0 17px;
    background-color: var(--color-background-default-default);
    position: relative;
    z-index: 10;
}
.splash-screen-available-content-box:after {
    position: absolute;
    content: "";
    display: block;
    top: 50%;
    left: 18px;
    box-sizing: border-box;
    width: calc(100% - 36px);
    height: 1px;
    background-color: var(--color-border-default-default);
}
.splash-screen-available-content {
    background-color: var(--color-background-brand-default);
    color: var(--color-button-active);
    font-size: 14px;
    font-family: var(--weight-600);
    padding: 4px 16px;
    border-radius: var(--size-radius-200);
    letter-spacing: 0.56px;
    min-width: calc(152px - 32px);
    box-sizing: border-box;
    text-transform: uppercase;
}
/* Transition classes provided by Vue */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
    transform: translate(-50%, -60%);
    opacity: 0;
}

.slide-up-enter-to,
.slide-up-leave-from {
    transform: translate(-50%, -50%);
    opacity: 1;
}
@media(max-width: 768px) {
    .splash-screen-web-cover {
        display: none;
    }
    .splash-screen-web {
        display: none;
    }
    .splash-screen-mobile {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 50;
        background-color: var(--color-background-default-default);
        overflow-y: auto;
        display: block;
    }
    .splash-screen-header {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 12px 16px;
        box-sizing: border-box;
        margin-top: 0;
    }
    .splash-screen-skip {
        color: var(--color-text-default-default);
        font-size: 16px;
        font-family: var(--weight-600);
    }
    .splash-screen-logo-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 18px;
        box-sizing: border-box;
    }
    .splash-screen-logo {
        height: 41px;
    }
    .splash-screen-title {
        text-align: center;
        font-size: 32px;
        color: var(--color-text-default-default);
        margin: 16px 0;
        line-height: 120%;
        padding: 0 18px;
        box-sizing: border-box;
    }
    .splash-screen-banner-box {
        width: 100%;
        padding: 0 18px;
        box-sizing: border-box;
    }
    .splash-screen-banner-img {
        width: 100%;
        height: auto;
        /* max-height: 500px; */
    }
    .splash-screen-available {
        margin: 16px 0;
    }
    .splash-screen-available-content-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 18px;
        box-sizing: border-box;
        position: relative;
    }
    .splash-screen-available-content-container {
        padding: 0 17px;
        background-color: var(--color-background-default-default);
        position: relative;
        z-index: 10;
    }
    .splash-screen-available-content-box:after {
        position: absolute;
        content: "";
        display: block;
        top: 50%;
        left: 18px;
        box-sizing: border-box;
        width: calc(100% - 36px);
        height: 1px;
        background-color: var(--color-border-default-secondary);
    }
    .splash-screen-available-content {
        background-color: var(--color-background-brand-default);
        color: var(--color-button-active);
        font-size: 14px;
        font-family: var(--weight-600);
        padding: 4px 16px;
        border-radius: var(--size-radius-200);
        letter-spacing: 0.56px;
    }
    .splash-screen-download-list {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 18px;
        box-sizing: border-box;
        gap: 8px;
        padding-bottom: 34px;
    }
    .splash-screen-download-item {
        background-color: var(--color-background-default-tertiary);
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 8px;
        box-sizing: border-box;
        flex: 1;
        width: 100%;
    }
    .splash-screen-download-icon {
        height: 40px;
        width: 40px;
    }
    .splash-screen-download-content {
        color: var(--color-text-default-default);
        font-size: 19px;
        letter-spacing: -1.33px;
        font-family: "Rubik400";
    }
    .splash-screen-download-small-text {
        font-size: 10px;
        letter-spacing: 0;
    }
    .slide-up-enter-from,
    .slide-up-leave-to {
        transform: translate(0, -10%);
        opacity: 0;
    }

    .slide-up-enter-to,
    .slide-up-leave-from {
        transform: translate(0, 0);
        opacity: 1;
    }
}
</style>
